<script>
    /* Stores */
	import { alt } from '../store.js';

	/* Components */  
	import Busca from './../components/Busca.svelte';
	import ListaImoveis from './../components/ListaImoveis.svelte'
	import PageHeader from '../components/PageHeader.svelte'

	//default filters
	let filters = {nt:1, cidade:'Canela',ordem:'5'};
	let numberOfItems = 0;
    let titlePage = 'Lista de Imóveis | ' + $alt;
	let pageHeader = getPageTitle();
	let order = '5';

	if (document.location.hash.length > 1) {
		const query = document.location.hash.substring(1).split('&').map(p=>p.split('='));
		for (const p of query) {
			filters[p[0]] = p[1];
		}
	}

	function search(e) {
		if (filters.tipo_negociacao != e.detail.tipo_negociacao) {
			const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.sell?'vendas':'locacao') + '#' + Object.entries(e.detail).filter(p=>p[1].length>0).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
			document.location = url;
		} else {
			document.location.hash = Object.entries(e.detail).filter(p=>p[1]!=='').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		}

		filters = {...e.detail, ...{ordem:order}};

		pageHeader = getPageTitle();
	}
	function orderChange() {
		search({detail:filters});
	}
	function getPageTitle() {

		let title = 'Ofertas ';

		if (filters.codigox != null && filters.codigox.length > 0) {
			title += ` | Código ${decodeURI(filters.codigox)}`;
		} else {

			if (filters.tipo_negociacao == atria.rent) {
			title += '- Alugar';
				} else if (filters.tipo_negociacao == atria.sell) {
				title += '- Comprar';
			}

			if (filters.cidade != null && filters.cidade.length > 0) {
				title += ` | ${decodeURI(filters.cidade)}`;
			}

		}

		if (numberOfItems > 0) {
			title += ` <span class="badge background-accent color-primary">${numberOfItems}</span>`;
		}

		return title;
	}
	function afterLoadRealties(json) {
		numberOfItems = json.NumberOfItems;

		pageHeader = getPageTitle();
	}
</script>

<svelte:head>
    <title>{titlePage}</title>
</svelte:head>

<h1 class="text-seo">{titlePage}</h1>

<section class="busca">
	<div class="container">	
		<Busca on:filter={search} />
	</div>
</section>

<PageHeader title={pageHeader} setPageTitle={false} classe="background-white mb-0" buttons={[]}>
	<div class="item">
		<div class="buttons">
			<select data-dropup-auto="false" class="selectpicker" bind:value={order} on:change={orderChange}>
				<option data-content="<i class='far fa-fw fa-sort-numeric-up'></i> Mais Dormitórios" value="5">Mais Dormitórios</option>
				<option data-content="<i class='far fa-fw fa-sort-numeric-down'></i> Menos Dormitórios" value="4">Menos Dormitórios</option>
				<option data-content="<i class='far fa-fw fa-sort-amount-up'></i> Maior Preço" value="1">Maior Preço</option>					
				<option data-content="<i class='far fa-fw fa-sort-amount-down'></i> Menor Preço" value="0">Menor Preço</option>
				<option data-content="<i class='far fa-fw fa-sort-alpha-down'></i> Bairros A-Z" value="6">Bairros A-Z</option>
				<option data-content="<i class='far fa-fw fa-sort-alpha-up'></i> Bairros Z-A" value="7">Bairros Z-A</option>
		</select>
		</div>
	</div>
</PageHeader>


<div class="container">
	<section class="section lista-imoveis pt-0">
		<ListaImoveis filters={filters} afterLoadRealties={afterLoadRealties} />
	</section>
</div>